import React from "react"
import './GalleryPage.scss'
import { Container } from "react-bootstrap";

function GalleryPage() {

    return (
        <div className="gallery-page">
            <div className="up-part">
                <div className="up-image"></div>
                <div className="portrait-container">
                    <div className="portrait">
                        <div className="portrait-img"></div>
                    </div>
                </div>
                <div className="potato">
                    <div className="potato-img"></div>
                    <div className="potato-txt">
                        картофельный бунт
                    </div>
                </div>
                <div className="flower"></div>
                <Container className="position-relative">
                    <div className="name-container">
                        <div className="name">
                            Владимир Иванович
                        </div>
                        <div className="dal">
                            ДАЛЬ
                        </div>
                    </div>
                </Container>
            </div>
            <div className="soon-part">
                <Container className="soon-container">
                    <div className="soon-bg">
                        <div className="soon-title-block">
                            <div className="soon-title">
                                {`Материалы выставки \nготовятся`}
                            </div>
                        </div>
                        <div className="soon-text-block">
                            <div className="soon-text">
                                {`скоро вы сможете погрузиться в виртуальную экспозицию о жизни и трудах Владимира Ивановича Даля`}
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default GalleryPage;